import React from 'react';
import { GetStaticProps } from 'next';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useI18n } from 'i18n';
import Head from 'src/components/Head';
import Layout from 'src/components/Layout';
import TermsContent from 'src/components/TermsContent';

export default function Terms(): React.ReactElement {
  const { t } = useI18n();

  return (
    <>
      <Head title={t('terms-title')} description={t('terms-description')} />
      <Layout>
        <Container maxWidth="md">
          <Typography sx={{ mt: 6, mb: 6 }} variant="h3" component="h1">
            利用条件
          </Typography>
          <TermsContent />
        </Container>
      </Layout>
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};
